import { CustomButton } from "@/components/custom/custom-button";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { DataTable } from "@/components/custom/data-table";
import { useAllCommissionPayouts } from "@/hooks/use-all-commission-payouts";
import { Box, Stack, styled } from "@mui/material";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getCommissionPayoutColumns } from "./_components/payout-column";
import {
  createCommissionPayout,
  updateCommissionPayout,
} from "@/services/pricing-config.service";
import CommissionPayoutDialog from "./_components/payout-dialog";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const CommissionPayouts = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const {
    data: payouts,
    isLoading,
    isError,
  } = useAllCommissionPayouts(true, queryParams);

  const [newPayoutOpen, setNewPayoutOpen] = useState(false);
  const [editPayout, setEditPayout] = useState(null);

  const handleEditClick = (payout) => setEditPayout(payout);
  const handleEditClose = () => setEditPayout(null);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search commission payouts..."
            />
          </Stack>

          <CustomButton
            onClick={() => setNewPayoutOpen(true)}
            isLoading={false}
            variantType="outline"
            sx={{ height: 35 }}
          >
            Add Payout
          </CustomButton>
        </Stack>

        <DataTable
          data={payouts?.data?.data ?? []}
          columns={getCommissionPayoutColumns(handleEditClick)}
          isLoading={isLoading}
          isError={isError}
        />
      </Card>

      <CommissionPayoutDialog
        open={newPayoutOpen}
        onClose={() => setNewPayoutOpen(false)}
        mutationFn={createCommissionPayout}
      />

      <CommissionPayoutDialog
        open={Boolean(editPayout)}
        onClose={handleEditClose}
        payout={editPayout}
        mutationFn={(payload) =>
          updateCommissionPayout({ id: editPayout?.id, ...payload })
        }
      />
    </RootWrapper>
  );
};

export default CommissionPayouts;